import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationInitService {

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) {}

  async initializeTranslations(): Promise<void> {
    const serverUrl = localStorage.getItem('server_url');
    if (!serverUrl || this.areTranslationsCached()) {
      return;
    }

    try {
      const response = await this.getAllTranslations(serverUrl);
      this.processAndCacheResponse(response);
    } catch (error) {
      console.log('Error initializing translations: ', error);
    }
  }

  async initializeTranslationsAfterServerUrl(): Promise<void> {
    const serverUrl = localStorage.getItem('server_url');
    if (serverUrl && !this.areTranslationsCached()) {
      await this.initializeTranslations();
    }
  }

  private areTranslationsCached(): boolean {
    try {
      const cached = localStorage.getItem('all_translations');
      const cacheTime = localStorage.getItem('all_translations_timestamp');

      if (!cached || !cacheTime) return false;
      if ((Date.now() - parseInt(cacheTime)) >= 24 * 60 * 60 * 1000) return false;

      const parsedCache = JSON.parse(cached);
      return Object.keys(parsedCache).some(key =>
        key !== 'translations' &&
        typeof parsedCache[key] === 'object' &&
        parsedCache[key] !== null &&
        Object.keys(parsedCache[key]).length > 0
      );
    } catch {
      return false;
    }
  }

  private async getAllTranslations(serverUrl: string): Promise<any> {
    const apiURL = serverUrl + 'b/system/v3/debtor_api/get_all_translations?source=debtor_API';
    return this.http.get(apiURL).toPromise();
  }

  async refreshTranslations(): Promise<void> {
    this.clearCache();
    await this.initializeTranslations();
  }

  private clearCache(): void {
    localStorage.removeItem('all_translations');
    localStorage.removeItem('all_translations_timestamp');
    localStorage.removeItem('available_languages');
    localStorage.removeItem('language_names');
  }

  private processAndCacheResponse(response: any): void {
    if (!response || typeof response !== 'object') return;

    const availableLanguages = Object.keys(response).filter(key =>
      key !== 'translations' &&
      typeof response[key] === 'object' &&
      response[key] !== null &&
      Object.keys(response[key]).length > 0
    );

    if (availableLanguages.length > 0) {
      localStorage.setItem('all_translations', JSON.stringify(response));
      localStorage.setItem('all_translations_timestamp', Date.now().toString());
      localStorage.setItem('available_languages', JSON.stringify(availableLanguages));

      if (response.translations) {
        localStorage.setItem('language_names', JSON.stringify(response.translations));
      }
    }
  }
}